import tokens from '../tokens/js/tokens';
import { breakpointMax as maxFn, breakpointMin as minFn } from './breakpoints.utils';
// Default breakpoints.
// -----------------------------------------------------------------------------
export const breakpoints = {
    // Values.
    s: tokens.breakpoints.s,
    m: tokens.breakpoints.m,
    l: tokens.breakpoints.l,
    xl: tokens.breakpoints.xl,
    '2xl': tokens.breakpoints['2xl'],
    // Methods.
    max: maxFn,
    min: minFn
};
//# sourceMappingURL=breakpoints.js.map